import { wait } from '@vacationtracker/shared/functions/wait'

export type CommitQueue = <T>(task: () => Promise<T>) => Promise<T>

// The holiday handlers read the location's holidays and write them back whole, so two posts in
// quick succession can each read the state before the other's write lands and undo it.
export function createCommitQueue(gapMs: number): CommitQueue {
  let tail: Promise<unknown> = Promise.resolve()
  return <T>(task: () => Promise<T>): Promise<T> => {
    const run = tail.then(task)
    tail = run.catch(() => undefined).then(() => wait(gapMs))
    return run
  }
}
